import type { TicketV1Props } from '../../model';
import { TicketCardV1 } from '../cards/TicketCardV1';
import { Carousel, Slide } from './common/Carousel';

export const TicketV1 = ({
  isLoading,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  onClick,
  tickets,
  selectedTicketType,
  ticketPriceModalInfo,
}: TicketV1Props) => {
  return (
    <Carousel data-testid="ticket-version-1" version={1}>
      {tickets.map((ticket) => (
        <Slide key={ticket.ticketType} version={1}>
          <TicketCardV1
            isLoading={isLoading}
            isRyanAirTicketingOrMarketingCarrierPresent={
              isRyanAirTicketingOrMarketingCarrierPresent
            }
            isVI={isVI}
            onClick={onClick}
            selectedTicketType={selectedTicketType}
            ticket={ticket}
            ticketPriceModalInfo={ticketPriceModalInfo}
          />
        </Slide>
      ))}
    </Carousel>
  );
};
